// HINWEIS 2026-08-02: Frueher (FMP) kamen Intraday-Zeitstempel als
// "YYYY-MM-DD HH:mm:ss" in der Boersen-Ortszeit (z.B. America/New_York fuer
// US-Symbole), deshalb rechnete parseExchangeTime() ueber den NY-Offset in
// UTC um. Seit der Ablösung durch EODHD (und den selbst mitgeschnittenen
// IG-Kerzen, siehe MarketdataChart.inc/marketdataWorker.mjs) liefern ALLE
// Quellen bereits reines UTC (EODHDs "datetime"-Feld hat "gmtoffset":0, live
// verifiziert; die selbst getrackten Kerzen (IB/Kraken) nutzen
// Date::toISOString()) - die NY-Offset-Umrechnung war dadurch falsch und
// verschob Zeitstempel um
// mehrere Stunden (live beobachtet: ein echter 23:38-CEST-Handelsschluss
// erschien faelschlich als "03:38", da 21:38 UTC faelschlich als 21:38
// NY-Ortszeit interpretiert und nochmal +4h "korrigiert" wurde). Deshalb
// jetzt nur noch reines UTC-Parsing, keine Boersenzeitzonen-Umrechnung mehr
// noetig. Eigene Datei, damit sowohl MarketdataDetailPanel.js (Live-Kurse-
// Detail) als auch MarketdataChartTile.js (Charts-Modul) dasselbe Parsing
// nutzen, ohne es zu duplizieren.

// Ermittelt den UTC-Offset einer Zeitzone zu einem gegebenen Zeitpunkt in
// Minuten (z.B. -240 fuer America/New_York waehrend EDT/Sommerzeit).
function getTimeZoneOffsetMinutes(timeZone, date) {
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone,
		hourCycle: 'h23',
		year: 'numeric', month: '2-digit', day: '2-digit',
		hour: '2-digit', minute: '2-digit', second: '2-digit',
	}).formatToParts(date).reduce((acc, part) => {
		acc[part.type] = part.value;
		return acc;
	}, {});
	const asUTC = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
	return (asUTC - date.getTime()) / 60000;
}

// dateString ist bereits UTC (siehe Hinweis oben) - akzeptiert sowohl das
// EODHD-/Backend-Format ("YYYY-MM-DD HH:mm:ss", ohne "T"/"Z") als auch schon
// vollstaendige ISO-Strings (die selbst getrackten IB-/Kraken-Kerzen liefern
// Date::toISOString(), also z.B. "2026-08-01T22:45:00.000Z") - deshalb kein
// blindes Anhaengen von "Z" mehr, sondern nur, wenn der String noch keine
// Zeitzonen-Angabe hat.
export function parseExchangeTime(dateString) {
	let isoString = dateString.includes('T') ? dateString : dateString.replace(' ', 'T');
	if (!/[Zz]|[+-]\d{2}:?\d{2}$/.test(isoString)) {
		isoString += 'Z';
	}
	return new Date(isoString);
}

// Wandelt eine reine Uhrzeit einer Boerse (z.B. Handelszeiten-Angabe
// "openingHour"/"closingHour" von MarketdataMarketHours.inc, Format "HH:mm:ss"
// oder "CLOSED") in die Browser-/Ortszeit um - gleiches Prinzip wie
// parseExchangeTime() oben, nur mit uebergebener statt fest verdrahteter
// Boersen-Zeitzone (die Handelszeiten-Angabe hat kein Datum, "heute" wird
// hier nur als Referenztag fuer die DST-Ermittlung gebraucht).
export function formatExchangeHourLocal(timeString, timeZone) {
	if (!timeString || timeString === 'CLOSED') {
		return null;
	}
	const today = new Date().toISOString().slice(0, 10);
	const naiveUtc = new Date(today + 'T' + timeString + 'Z');
	const offsetMinutes = getTimeZoneOffsetMinutes(timeZone, naiveUtc);
	const localDate = new Date(naiveUtc.getTime() - offsetMinutes * 60000);
	return localDate.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}
